import React, { useState, useEffect, useMemo } from 'react'
import Popup from '../../../../../../presentationals/Popup/Popup.component'
import { getListUnmappedCampaigns, getAllAggregatorsNamesList, getAllPartnerNamesListbyAggregatorNames, SavecampgaingsMappingData } from '../../../../actioncreatormarketing'
export default function MapCampaigns({  setLoader, setSaveHandler, setMapDisabled }) {
const getUniqueKey = (val) => `${val.campaignId}-${val.partnerName}`
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [campaignSelected, setcampaignSelected] = useState([])
    const [campaignUnmapped, setcampaignUnmapped] = useState([])
    const [ListData, setListData] = useState({ aggregatorList: [], partner: [] })
    const [assignPopup, setAssignPopup] = useState(false)
    const [search, setsearch] = useState("")
    const [objectData, setObjectData] = useState({
        companyName: "",
        partnerName: "",
    })

    useEffect(() => {
        getListUnmappedCampaignsfn()
        getAggregatorNamesListApi()
    }, [])

    // ================= API CALLS =================

    const getAggregatorNamesListApi = () => {
        setLoader(true)
        getAllAggregatorsNamesList(callback => {
            setLoader(false)
            setListData({ aggregatorList: callback?.data ?? [], partner: [] })
        })
    }

    const getAllPartnerNamesListbyAggregatorNamesApi = (val) => {
        setLoader(true)
        getAllPartnerNamesListbyAggregatorNames(val, callback => {
            setLoader(false)
            setListData((prev) => ({
                ...prev,
                partner: callback?.data ?? []
            }))
        })
    }

    const getListUnmappedCampaignsfn = () => {
        setLoader(true)
        getListUnmappedCampaigns(callback => {
            setLoader(false)
            setcampaignUnmapped(callback ?? [])
        })
    }

    // ================= SEARCH FILTER =================

    const filteredCampaigns = useMemo(() => {
        return campaignUnmapped.filter((item) =>
            item?.campaignName?.toLowerCase().includes(search.toLowerCase())
        )
    }, [campaignUnmapped, search])

    // ================= CHECKBOX HANDLING =================

const handleSelectBox = (e, val) => {
    const key = getUniqueKey(val)
    if (e.target.checked) {
        setcampaignSelected(prev => [...prev, { key, campaignId: val.campaignId }])  // ← always store object
    } else {
        setcampaignSelected(prev => prev.filter(item => item.key !== key))
    }
}

const handleSelectAllBox = (e) => {
    if (e.target.checked) {
        const all = filteredCampaigns.map(val => ({ key: getUniqueKey(val), campaignId: val.campaignId }))
        setcampaignSelected(all)
    } else {
        setcampaignSelected([])
    }
}

    // ================= DROPDOWN HANDLING =================

    const handleChange = (e, type) => {
        setObjectData((prev) => ({
            ...prev,
            [type]: e.target.value
        }))

        if (type === "companyName") {
            const ar = ListData?.aggregatorList?.filter(
                (el) => el.aggregatorId == e.target.value
            )
            getAllPartnerNamesListbyAggregatorNamesApi(ar?.[0]?.companyName ?? "")
        }
    }

    // ================= SAVE HANDLING =================

    useEffect(() => {
        setMapDisabled(campaignSelected.length === 0)
    }, [campaignSelected])

    useEffect(() => {
        setSaveHandler(() => saveRegistration)
    }, [campaignSelected])

    const saveRegistration = async () => {
        setAssignPopup(true)
    }

    const handlesaveRegistration = async () => {

        const payload = campaignSelected.map(({campaignId}) => ({
            campaignId,
            aggregatorId: objectData.companyName,
            partnerId: objectData.partnerName,
        }))

        setLoader(true)

        SavecampgaingsMappingData(payload, callback => {

            setLoader(false)

            if (callback === 'success') {
                setPopup({ show: true, popupStatus: "Data Save Successfully !" })
            } else {
                setPopup({ show: true, popupStatus: "Please try again later !" })
            }

            setMapDisabled(true)
            setAssignPopup(false)
            setcampaignSelected([])
            getListUnmappedCampaignsfn()
            removePopup()
        })
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const handeclosePopup = () => {
        setAssignPopup(false)
        setcampaignSelected([])
        setObjectData({
            companyName: "",
            partnerName: "",
        })
    }
    return (
        <>
            {popup?.show && (
                <Popup closePopup={closePopup} popupStatus={popup?.popupStatus} />
            )}

            <div className="row">
                <div className="col-xs-12">

                    {/* SEARCH */}
                    <div className="HeadingFilter-main-filters">
                        <div className="row">
                            <div className="col-xl-3 col-lg-10 col-xs-12" style={{ marginTop: "5px" }}>
                                <div className='customInputSearch-bar'>
                                    <i className='fa fa-search'></i>
                                    <input
                                        placeholder='Search Campaign Name'
                                        className='customInput'
                                        value={search}
                                        onChange={(e) => setsearch(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* TABLE */}
                    <div className="customDash-table" style={{ marginTop: '40px' }}>
                        <h5>Unmapped Campaigns</h5>

                        <div className='main-customized-table'>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th>
                                            <input
                                                type='checkbox'
                                                onChange={handleSelectAllBox}
                                                checked={
        filteredCampaigns.length > 0 &&
        filteredCampaigns.every(item =>                                          // ← match by composite key
            campaignSelected.some(s => s.key === getUniqueKey(item))
        )
    }
                                            />
                                        </th>
                                        <th>Campaign Name</th>
                                        <th>Partner Name</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {filteredCampaigns.length > 0 ? (
                                        filteredCampaigns.map((val) => {
                                            const uniqueKey = getUniqueKey(val)
                                            return (
                                                <tr key={uniqueKey}>
                                                    <td>
                                                        <input
                                                            type='checkbox'
                                                            onChange={(e) =>
                                                                handleSelectBox(e, val)
                                                            }
                                                            checked={campaignSelected?.some(item => item?.key === uniqueKey)}
                                                        />
                                                    </td>
                                                    <td>{val?.campaignName ?? ""}</td>
                                                    <td>{val?.partnerName ?? ""}</td>
                                                </tr>
                                            )
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="3" style={{ textAlign: "center" }}>
                                                No matching campaigns
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {
                assignPopup ?
                    <div className="background-blur">

                        <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px' }}>
                            <i onClick={() => handeclosePopup()} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>

                            <div className="row from-group">
                                <div className="col-sm-6 col-xs-12">
                                    <div className='customInput-box'>
                                        <label htmlFor="" className="label-new">Aggregator</label>
                                        <select className='customInput-new' type="text" value={objectData?.companyName} onChange={(e) => handleChange(e, "companyName")} >
                                            <option value={""}>Select Option</option>
                                            {
                                                ListData?.aggregatorList?.length > 0 ? ListData?.aggregatorList?.map((Val, id) => {
                                                    return (
                                                        <option value={Val?.aggregatorId}>{Val?.companyName}</option>
                                                    )
                                                })
                                                    : ""}

                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <div className='customInput-box'>
                                        <label htmlFor="" className="label-new">Partner</label>
                                        <select className='customInput-new' type="text" value={objectData?.partnerName} onChange={(e) => handleChange(e, "partnerName")} >
                                            <option value={""}>Select Option</option>
                                            {
                                                ListData?.partner?.length > 0 ? ListData?.partner?.map((Val, id) => {
                                                    return (
                                                        <option value={Val?.partnerId}>{Val?.partnerName}</option>
                                                    )
                                                })
                                                    : ""}

                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row from-group text-center">
                                <div className="col-xs-12">
                                    <button className="btn btn-primary" style={{ marginTop: '10px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }} onClick={() => handlesaveRegistration()}>Assign</button>                         </div>

                            </div>
                        </div>
                    </div>
                    : ""}


        </>
    )
}
